import { george, i18n, observer, pr, React, RouteComponentProps, theme } from "aaa";
import { observable } from "mobx";
import { pushRoute } from "stores/RouterFunctions";
import { ChooseEmail } from "../common/ChooseEmail";
import { ui } from "../util/uiHelpers";
import { GIGActivationDialog } from "./GIGActivationDialog";
import { GIGRoutes } from "./GIGRoutes";
import { GIGStore } from "./GIGStore";

type IProps = RouteComponentProps<{}> & {
    store: GIGStore
};

@observer
export class GIGActivation extends React.Component<IProps, {}> {
    @observable showDialog = false;

    onContinue = () => {
        pushRoute(GIGRoutes.PRECONTRACT);
    }

    render() {
        return (
            <>
                <george.BackgroundWithNavBar>
                    <george.PageWithActionButton>
                        <george.Card onClick={() => this.showDialog = true}>
                            <george.CardSectionTitle title={ui.__("gig.activation.header")} />
                            <george.CardSectionContent>
                                <pr.HFlexCentered style={{ width: "100%" }}>
                                    <pr.P_14_CONTENT>
                                        <i18n.FormattedMessage id="gig.activation.info" />
                                    </pr.P_14_CONTENT>
                                    <div> {/* Need extra div to make flex work correctly with svg icon */}
                                        <pr.IconInfo
                                            style={{
                                                marginLeft: 5,
                                                width: 30,
                                                height: 30,
                                                color: theme.customColors.georgeLightBlue,
                                            }}
                                        />
                                    </div>
                                </pr.HFlexCentered>
                            </george.CardSectionContent>
                        </george.Card>

                        <ChooseEmail
                            contactsStore={this.props.store.contactsStore}
                            description={ui.__("gig.card.email.text")}
                        />

                        <george.Card>
                            <george.CardSectionTitle title={ui.__("gig.card.info.title")} />
                            <george.CardSectionContent>
                                <pr.P_14_CONTENT>{ui.__("gig.precontract.info")}</pr.P_14_CONTENT>
                            </george.CardSectionContent>
                        </george.Card>

                        <george.ActionButton
                            messageId="button.continue"
                            onClick={this.onContinue}
                            isLoading={this.props.store.isLoading()}
                            disableButton={!this.props.store.contactsStore.selectedEmailAddressId}
                            primary
                        />
                    </george.PageWithActionButton>
                </george.BackgroundWithNavBar>
                <GIGActivationDialog
                    show={this.showDialog}
                    onClose={() => {
                        this.showDialog = false;
                    }}
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gig/GIGActivation.tsx